import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToPortalSummary,
  type PortalSummary,
  type PortalSummaryApiResource,
} from './portalSummaryApi.types';

export async function fetchOwnPortalSummary(): Promise<PortalSummary> {
  const response = await httpClient.get<PortalSummaryApiResource>('/me/portal-summary');
  return mapApiResourceToPortalSummary(response.data);
}
